import useGetEvents from '@src/hooks/useGetEvents'
import useGetCapitals from '@src/hooks/useGetCapitals'
import useGetOpportunities from '@src/hooks/useGetOpportunites'
import useGetCompanies from '@src/hooks/useGetCompanies'
import useGetSupport from '@src/hooks/useGetSupport'
import { Capital } from '@src/utils/resolvers'

export default (past = false) => {
  const minTime = new Date().setHours(0, 0, 0, 0)
  const events = useGetEvents().filter(
    card => past || card.date.getTime() >= minTime
  )

  const opportunities = useGetOpportunities().filter(
    card => past || card.date.getTime() >= minTime
  )
  const capitals: Capital[] = useGetCapitals()

  const companies = useGetCompanies()

  const support = useGetSupport()

  const cards = [
    ...events,
    ...opportunities,
    ...capitals,
    ...companies,
    ...support
  ]
  return [
    ...cards
      .filter(a => a.date && a.date.getTime() >= new Date().getTime())
      .sort((a, b) => a.date.getTime() - b.date.getTime()),
    ...cards
      .filter(a => a.date && a.date.getTime() < new Date().getTime())
      .sort((a, b) => b.date.getTime() - a.date.getTime()),
    ...cards.filter(a => !a.date)
  ]
}
